import { useEffect } from 'react';

import { rateComparisonSubject } from '../../store/csw/rate-recommendation.observables';

export const useLegacyShippingServiceRecommendation = ({ fulfillmentPlanId, compareRates, setShouldShowComparison }) => {
  useEffect(() => {
    const subscription = rateComparisonSubject.subscribe(
      ({ ratedFulfillmentPlanId, isComparing, userRates, comparedRates, comparedService, metadata }) => {
        if (ratedFulfillmentPlanId !== fulfillmentPlanId) {
          return;
        }

        if (isComparing) {
          setShouldShowComparison(false);
          return;
        }

        compareRates({
          userRatesTotalCost: userRates.totalCost,
          comparedRatesTotalCost: comparedRates.totalCost,
          comparedService,
          metadata,
        });
      },
    );

    return () => subscription.unsubscribe();
  }, [compareRates, fulfillmentPlanId, setShouldShowComparison]);
};
